import isEmail from 'validator/lib/isEmail'

const ACKLEN_EMAIL_DOMAIN = '@acklenavenue.com'

export const isAcklenEmail = (email: string) =>
  email.toLowerCase().endsWith(ACKLEN_EMAIL_DOMAIN)

export const validateEmail = (email: string) =>
  isEmail(email) && isAcklenEmail(email)

export const getEmailError = (
  email: string,
  options?: { required?: boolean },
): string | null => {
  const trimmed = email.trim()
  if (!trimmed) {
    return options?.required ? 'Email is required' : null
  }
  if (!isEmail(trimmed)) {
    return 'Enter a valid email address'
  }
  if (!isAcklenEmail(trimmed)) {
    return `Email must use ${ACKLEN_EMAIL_DOMAIN}`
  }
  return null
}
